import { RootState } from '@/plugins/store';
import { GetterTree } from 'vuex';
import { SuiviFinancierState } from '.';

export const getters: GetterTree<SuiviFinancierState, RootState> = {
    getSuiviFinancesTableHeader(state) {
        return state.tableHeader;
    },
    getSuiviFinancesScroll(state) {
        return state.scroll;
    },
    getSuiviFinancesItems(state) {
        return state.factures;
    },
    getSuiviFinancesFullItems(state) {
        return state.facturesWithChantierId;
    },
    getSuiviFinancesIsLoading(state) {
        return state.isLoading;
    },
    getSuiviFinancesXlsIsLoading(state) {
        return state.xlsLoading;
    },
    getSuiviFinancesPage(state) {
        return state.pageSuiviFinancier;
    },
    getSuiviFinancesNbOfPages(state) {
        return state.nbOfPages;
    },
    getSuiviFinancesSort(state) {
        return state.sort;
    },
    getSuiviFinancesSiteList(state) {
        return state.siteList;
    },
    getSuiviFinancesPdfIsLoading(state) {
        return state.pdfLoading;
    },
};
